/***
 * n 個づつに分割した配列を返します
 * @param arr
 * @param n
 * @returns {[array]}
 */
export function splitArray(arr, n) {
  const list = []
  const listLen = Math.ceil(arr.length/n)
  for (let i = 0; i < listLen; i++) {
    const start = i * n
    const subArr = arr.slice(start, start + n)
    list.push(subArr)
  }
  return list
}

/***
 * UNIX時間を年月日の文字列配列に変換して返します
 * @param intTime
 * @returns {[string, string, string]}
 */
export function ymd(intTime) {
  const date = new Date(1000 * intTime)
  const year = date.getFullYear().toString().substr(2, 2)
  const month = ('0' + (date.getMonth() + 1)).slice(-2)
  const day = ('0' +  date.getDate()).slice(-2)
  return [year, month, day]
}

/***
 * バイナリを画像URIに変換して返します
 * @param bytes
 * @returns {string}
 */
export function toJpegURI(bytes) {
  const src = "data:image/jpeg;base64," + toString(bytes)
  return src
}

/***
 * バイナリを動画URIに変換して返します
 * @param bytes
 * @returns {string}
 */
export function toMP4URI(bytes) {
  const src = "data:video/mp4;base64," + toString(bytes)
  return src
}

function toString(bytes) {
  let binaryData = ""
  for (let i = 0, len = bytes.byteLength; i < len; i++) {
    binaryData += String.fromCharCode(bytes[i])
  }
  return window.btoa(binaryData)
}

/***
 * 残り日数を返します
 * @param intTime
 * @returns {number}
 */
export function daysLeft(intTime) {
  const now = Math.floor(new Date().getTime() / 1000)
  if (intTime <= now) {
    return 0
  }
  const s = intTime - now
  return Math.floor(s / (60 * 60 * 24))
}

/***
 * jpeg画像をダウンロードします
 * @param bytes
 * @param name
 */
export function downloadJPEG(bytes, name) {
  if (typeof name !== "string") {
    name = name.toString()
  }
  if (!name.endsWith('.jpeg') || !name.endsWith('.jpg') || !name.endsWith('.JPEG')) {
    name += '.jpeg'
  }
  download(bytes, 'image/jpeg', name)
}

/***
 * mp4動画をダウンロードします
 * @param bytes
 * @param name
 */
export function downloadMP4(bytes, name) {
  if (typeof name !== "string") {
    name = name.toString()
  }
  if (!name.endsWith('.mp4') || !name.endsWith('.MP4')) {
    name += '.mp4'
  }
  download(bytes, 'video/mp4', name)
}

function download(bytes, contentType, name) {
  const blob = new Blob([bytes], { "type" : contentType })
  const a = document.createElement('a')
  a.target = "_blank"
  a.href = window.URL.createObjectURL(blob)
  a.download = name
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

/***
 * 指定した範囲の数値配列を返します
 * @param start
 * @param end
 * @returns {*[]}
 */
export function numbers(start, end) {
  return Array(end - start + 1).fill().map((e,i) => start + i)
}

/***
 * Uint8Arrayをbase62文字列に変換する
 * @param array
 * @returns {string}
 */
export function genBase62(array) {
  const base = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
  const base_num = 256
  const dst_num = 62
  let indices = convert(array, base_num, dst_num)
  let str = ""
  for (let i = 0; i < indices.length; i++) {
    str += base[indices[i]]
  }
  return str
}
function convert (number, src_base, dst_base) {
  let res = [];
  let quotient;
  let remainder;

  while (number.length)
  {
    // divide successive powers of dst_base
    quotient = [];
    remainder = 0;
    const len = number.length;
    for (let i = 0 ; i != len ; i++)
    {
      let accumulator = number[i] + remainder * src_base;
      let digit = accumulator / dst_base | 0; // rounding faster than Math.floor
      remainder = accumulator % dst_base;
      if (quotient.length || digit) quotient.push(digit);
    }

    // the remainder of current division is the next rightmost digit
    res.unshift(remainder);

    // rinse and repeat with next power of dst_base
    number = quotient;
  }

  return res;
}

/***
 * ０埋めした数字列を返します
 * @param number
 * @param digit
 * @returns {string}
 */
export function zeroPadding(number, digit) {
  const numberLength = String(number).length
  if (digit > numberLength) {
    return new Array((digit - numberLength) + 1).join(0) + number
  }
  return number.toString()
}

import Crypt from 'crypto'
/***
 * ハッシュ化した文字列を返す
 * @param str
 */
export function toHash(algorithm, str) {
  if (!str) {
    return ""
  }
  let val = str
  if (typeof val !== "string") {
    val = str.toString()
  }
  const hash = Crypt.createHash(algorithm)
  return hash.update(val).digest('hex')
}

/***
 * url safe base64をデコードする
 * @param str
 * @returns {string}
 */
export function decodeUrlSafeBase64(str) {
  try{
    return atob(str.replace(/_/g, '/').replace(/-/g, '+'))
  } catch {
    return ""
  }
}

import parser from 'ua-parser-js'
export function isIOS() {
  const parse = new parser.UAParser()
  return parse.getOS().name === "iOS"
}

export function isAndroid(){
  const parse = new parser.UAParser()
  return parse.getOS().name === "Android"
}

export function getOSVersion() {
  const parse = new parser.UAParser()
  return parseFloat(parse.getOS().version)
}

/***
 * 入力不可なstringを削除して返却する
 * @param str
 */
export function replaceInputtableString(str) {
  const pattern = new RegExp("[^" +
    "\u0020-\u007F" + // Basic Latin
    "\u0370-\u03FF" + // Greek and Coptic
    "\u0400-\u04FF" + // Cyrillic
    "\u2000-\u206F" + // General Punctuation
    "\u2150-\u218F" + // Number Forms
    "\u2190-\u21FF" + // Arrows
    "\u2200-\u22FF" + // Mathematical Operators
    "\u2460-\u24FF" + // Enclosed Alphanumerics
    "\u25A0-\u25FF" + // Geometric Shapes
    "\u2600-\u26FF" + // Miscellaneous Symbols
    "\u2E80-\u2EFF" + // CJK Radicals Supplement
    "\u2F00-\u2FDF" + // Kangxi Radicals
    "\u3000-\u303F" + // CJK Symbols and Punctuation
    "\u3040-\u309F" + // Hiragana
    "\u30A0-\u30FF" + // Katakana
    "\u3200-\u32FF" + // Enclosed CJK Letters and Months
    "\u3300-\u33FF" + // CJK Compatibility
    "\u4E00-\u9FFF" + // CJK Unified Ideographs
    "\uF900-\uFAFF" + // CJK Compatibility Ideographs
    "\uFF00-\uFFEF" + // Halfwidth and Fullwidth Forms
    "]", 'g')
  return str.replace(pattern, '')
}
